import { useQuery } from 'react-query';

import { getUnmountedSigns } from 'api/InteractiveMap/getUnmountedSigns';

export const useGetUnmountedSigns = (siteSlug: string, signType: 'vul' | 'enc') => {
  const { data, refetch, isLoading, isRefetching } = useQuery(
    ['unmountedSigns', signType],
    () => getUnmountedSigns(siteSlug),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      enabled: !!siteSlug,
      select: data => (signType === 'vul' ? data.vul : data.enc),
    },
  );

  return { data, refetch, isLoading, isRefetching };
};
